var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.15117 12.9726H10.8807L10.9071 12.9998C12.5774 13.0194 14.0122 11.785 14.2874 10.092C14.5625 8.39901 13.5958 6.75256 12.01 6.21338C11.5521 3.96208 9.50284 2.43813 7.27866 2.69482C5.05448 2.95151 3.38527 4.9046 3.42472 7.2042C2.05586 7.59696 1.17544 8.96319 1.35784 10.4116C1.54024 11.86 2.7301 12.9509 4.15117 12.9726ZM4.44835 7.31956C4.43369 5.39944 5.9347 3.82966 7.80321 3.81101C9.42223 3.84819 10.7853 5.06633 11.0458 6.70879L11.1052 7.03454L11.4354 7.10919C12.5952 7.42311 13.3508 8.56951 13.2041 9.79273C13.0574 11.0159 12.0535 11.9395 10.8543 11.9547H4.15117C3.17632 11.9218 2.39127 11.1216 2.35138 10.1202C2.3115 9.11873 3.0303 8.25529 3.99927 8.14072L4.48137 8.09321L4.44835 7.59781V7.31956Z",
    fill: "#0F67BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.222efc4ab23eab2e48ca271f2480a023.svg";
export { ForwardRef as ReactComponent };